export const NODE_NAME = 'embed';
